export const tokenGetterFn = () => {
  return localStorage.getItem('washeria_at');
}